import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import { LIFESTYLE, STORY_CHAPTERS, QUALITY_STANDARDS, BUSINESS } from "@/data/content";

export default function Story() {
  useEffect(() => { document.title = "Our Story · Washington Family Provisions"; }, []);
  return (
    <div>
      <section className="relative grain overflow-hidden">
        <img src={LIFESTYLE.family} alt="A warm family gathering outdoors" className="h-[52vh] w-full object-cover" />
        <div className="absolute inset-0 bg-wood-900/45" />
        <div className="absolute inset-0 z-[2] mx-auto flex max-w-5xl flex-col justify-center px-5 md:px-8">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-honey-soft">Since our first small batch</p>
          <h1 className="mt-3 font-serif text-5xl text-cream md:text-7xl">The Washington Family story</h1>
        </div>
      </section>

      <section className="mx-auto max-w-3xl px-5 py-20 md:px-8">
        <Reveal>
          <p className="font-serif text-2xl leading-relaxed text-wood-800 md:text-3xl">
            Washington Family Provisions is a family-rooted wellness brand from Northern California. We create premium honey, artisan teas, and botanical body care — thoughtfully curated with quality ingredients and timeless craftsmanship — to bring everyday luxury to your kitchen and your self-care routine.
          </p>
        </Reveal>
        <div className="mt-14 space-y-12">
          {STORY_CHAPTERS.map((c) => (
            <Reveal key={c.number}>
              <div className="flex gap-6 border-t border-wood-900/10 pt-8">
                <span className="font-serif text-4xl text-honey">{c.number}</span>
                <div>
                  <h2 className="font-serif text-3xl text-wood-900">{c.title}</h2>
                  <p className="mt-3 text-wood-700">{c.body}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="bg-sage text-cream">
        <div className="mx-auto max-w-7xl px-5 py-20 md:px-8">
          <Reveal><h2 className="font-serif text-4xl md:text-5xl">What we stand for</h2></Reveal>
          <div className="mt-12 grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
            {QUALITY_STANDARDS.map((q) => (
              <div key={q.title} className="border-t border-cream/25 pt-5">
                <h3 className="font-serif text-2xl">{q.title}</h3>
                <p className="mt-2 text-sm text-cream/80">{q.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-3xl px-5 py-20 text-center md:px-8">
        <Reveal>
          <h2 className="font-serif text-4xl text-wood-900 md:text-5xl">Begin your own ritual</h2>
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <Link to="/shop/honey" className="rounded-full bg-wood-900 px-7 py-4 text-sm font-medium text-cream hover:bg-honey-dark">Shop Honey</Link>
            <Link to="/shop/tea" className="rounded-full border border-wood-900/30 px-7 py-4 text-sm font-medium text-wood-900 hover:bg-wood-900 hover:text-cream">Shop Tea</Link>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
